import React from 'react';
import phone from '@/public/assets/phone.png';
import phone2x from '@/public/assets/phone@2x.png';
import phone3x from '@/public/assets/phone@3x.png';
import ImgIcon from '../BaseIcon';

const Phone = () => (
    <ImgIcon
        srcset={`${phone},
                ${phone2x} 2x,
                ${phone3x} 3x,`}
        src={phone3x}
        alt="phone"
    />
);

export default Phone;
